<template>
  <div class="static warewashing">
	<div class="logo-left">
	  <a href="/storesafe" target="_parent">
		<img src="@/assets/images/storesafe-logo.png" width="100%" alt="StoreSafe logo" />
	  </a>
	</div>
	<h1>{{ $t('warewashing.page_title') }}</h1>
  </div>

  <div class="static-grey">
	  {{ $t('warewashing.intro_text') }}
	</div>
	<div class="static-white">
		
	  <div class="static-split">
		  <div class="split-image">
			<img src="@/assets/images/warewashing_sink-station.jpg" alt="Dish Caddy" class="rounded">
		  </div>
		  <div class="split-content">
			<h2>{{ $t('warewashing.camshelving_elevation_series_wall_shelvi') }}</h2>
			<p>{{ $t('warewashing.store_cleaning_supplies_and_airdry_tools') }}</p>
			<a href="https://www.cambro.com/Products/warewashing/dish-caddies/compact-adjustable-dish-caddy-s-series/" target="_blank" class="learn-more">
			<button @mouseover="isHovered = true" 
					@mouseleave="isHovered = false"
					:class="{ 'hovered': isHovered }">
			  {{ $t('receiving.learn_more_btn')}}
			</button></a>
		  </div>
	   </div>
	   
	   <div class="static-split red-line">
		 <div class="split-image">
		   <img src="@/assets/images/warewashing_camrack.jpg" alt="Camrack w/ Camdolly">
		 </div>
		 <div class="split-content">
		   <h2>{{ $t('warewashing.camrack_w_camdolly') }}</h2>
		   <p>{{ $t('warewashing.the_camrack_is_designed_with_closed_outs') }}</p>
		   <a href="https://www.cambro.com/Products/warewashing/camracks/" target="_blank" class="learn-more">
		   <button @mouseover="isHovered = true" 
				   @mouseleave="isHovered = false"
				   :class="{ 'hovered': isHovered }">
			 {{ $t('receiving.learn_more_btn')}}
		   </button></a>
		 </div>
	  </div>
	  
	  <div class="static-testimonial">
		 <div class="quote-top"><img src="@/assets/images/quote-top.jpg" /></div>
		 <div class="testimonial-quote">{{ $t('warewashing.they_go_through_the_dishwasher_perfectly') }}&quot;</div>
		 <div class="testimonial-pic"><img src="@/assets/images/warewashing_testimonial-2.jpg" /></div>
		 <div class="testimonial-name"><a href="https://blog.cambro.com/2022/10/17/camracks-the-best-way-to-protect-store-and-transport-your-glassware/" target="_blank">{{ $t('warewashing.simon_harris_director_of_food_and_bevera') }}</a></div>
	 </div>
		 
	   <div class="static-split red-line">
			<div class="split-image">
			  <img src="@/assets/images/warewashing_camshelving.jpg" alt="Camshelving Elements">
			</div>
			<div class="split-content">
			  <h2>{{ $t('warewashing.camshelving_elements_xtra_series_vertica') }}</h2>
			  <p>{{ $t('warewashing.this_mobile_rack_employs_removable_7slot') }}</p>
			  <a href="https://www.cambro.com/Industries/HC/healthcare-drying-racks/camshelving-elements-series-vertical-drying-rack/" target="_blank" class="learn-more">
			  <button @mouseover="isHovered = true" 
					  @mouseleave="isHovered = false"
					  :class="{ 'hovered': isHovered }">
				{{ $t('receiving.learn_more_btn')}}
			  </button></a>
			</div>
		 </div>
	   
	  <div class="static-split red-line">
		  <div class="split-image">
			<img src="@/assets/images/warewashing_dish-caddy.jpg" alt="Dish Caddy">
		  </div>
		  <div class="split-content">
			<h2>{{ $t('warewashing.dish_caddy') }}</h2>
			<p>{{ $t('warewashing.the_extremely_durable_construction_holdi') }}</p>
			<a href="https://www.cambro.com/Products/warewashing/dish-caddies/compact-adjustable-dish-caddy-s-series/" target="_blank" class="learn-more">
			<button @mouseover="isHovered = true" 
					@mouseleave="isHovered = false"
					:class="{ 'hovered': isHovered }">
			  {{ $t('receiving.learn_more_btn')}}
			</button></a>
		  </div>
	   </div>
	   
	   <div class="static-testimonial">
		   <div class="quote-top"><img src="@/assets/images/quote-top.jpg" /></div>
		   <div class="testimonial-quote">{{ $t('warewashing.cambro_did_it_again_by_keeping_the_essen')}}&quot;</div>
		   <div class="testimonial-pic"><img src="@/assets/images/warewashing_testimonial-1.png" /></div>
		   <div class="testimonial-name"><a href="https://blog.cambro.com/2019/05/10/cambro-manufacturing-debuts-compact-adjustable-dish-caddy-s-series/" target="_blank">{{ $t('warewashing.ben_lafleche_executive_chef_at_the_hilto')}}</a></div>
	   </div>
		
		<div class="sub-white">
			<h1>{{ $t('receiving.other_resources_title') }}</h1>
			<div class="home-categories">
				<a href="/storesafe/receiving" target="_parent" class="home-cat"><div class="cat-receiving"></div></a>
				<a href="/storesafe/storage" target="_parent" class="home-cat"><div class="cat-storage"></div></a>
				<a href="/storesafe/preparation" target="_parent" class="home-cat"><div class="cat-prep"></div></a>
				<a href="/storesafe/service" target="_parent" class="home-cat"><div class="cat-service"></div></a>
				<a href="#" class="home-cat dimmed"><div class="cat-warewashing"></div></a>
			</div>
		</div>
	</div>
  
  
  </template>
  
